/**
 * CTA Type Enumeration for SNAPS2
 * Defines all possible Call-to-Action types used across client and server
 *
 * Usage:
 * - Server: Strategies assign snaps2ID using these constants
 * - Client: Components identify CTA type to render differently
 */
class CtaTypeEnum {
    /**
     * Where to Buy CTA - Redirects to purchase locations
     */
    static WTB = 'wtb'

    /**
     * Service Locator CTA - Find service centers/dealers
     * Has rank property (1-3) for positioning
     */
    static SERVICE_LOCATOR = 'serviceLocator'

    /**
     * Lead Form 1 CTA - Primary lead capture form
     */
    static LEAD_FORM_1 = 'leadForm1'

    /**
     * Lead Form 2 CTA - Secondary lead capture form
     */
    static LEAD_FORM_2 = 'leadForm2'

    /**
     * Contact Acquisition CTA - Contact form for inquiries
     */
    static CONTACT_ACQUISITION = 'contactAcquisition'

    /**
     * Call to Action CTA - Generic action button with URL
     */
    static CALL_TO_ACTION = 'callToAction'

    /**
     * Post Purchase Form CTA - Support form for existing customers
     */
    static POST_PURCHASE_FORM = 'postPurchaseForm'

    /**
     * Get all CTA types as an array
     * @returns {Array<string>} Array of all CTA type values
     */
    static getAllTypes() {
        return [
            CtaTypeEnum.WTB,
            CtaTypeEnum.SERVICE_LOCATOR,
            CtaTypeEnum.LEAD_FORM_1,
            CtaTypeEnum.LEAD_FORM_2,
            CtaTypeEnum.CONTACT_ACQUISITION,
            CtaTypeEnum.CALL_TO_ACTION,
            CtaTypeEnum.POST_PURCHASE_FORM
        ]
    }

    /**
     * Check if a given type is valid
     * @param {string} type - Type to validate
     * @returns {boolean} True if valid CTA type
     */
    static isValidType(type) {
        return CtaTypeEnum.getAllTypes().includes(type)
    }
}

export default CtaTypeEnum
